import { DefaultAPIInstance } from "@/api";

const personal_data_url = 'users/';

export const PersonalAPI = {
    getPersonalData(userId) {
        return DefaultAPIInstance.get(`${personal_data_url}${userId}/billing/`)
    }
}
